import { r as registerInstance, h, H as Host } from './index-dba4409d.js';
import { R as ReportItem } from './report-row-f82615d9.js';

const PaginatedReportItems = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.pageSize = 5;
        this.items = [];
        this.t = undefined;
        this.isOnMachinePage = false;
        this.visibleAmount = this.pageSize;
    }
    /**
     * Load more items when the button is clicked
     */
    loadMore() {
        this.visibleAmount += this.pageSize;
    }
    render() {
        return (h(Host, { key: '1048c83aa36a344c2c99ed6367bced9596686152' }, this.items.slice(0, this.visibleAmount).map((doc) => (h("div", { class: "ux-info-box" }, h(ReportItem, { t: this.t, document: doc, title: this.t(`mf-service-calls:serviceReports.reportTypes.${doc.mission.assignmentType}`), isOnMachinePage: this.isOnMachinePage })))), this.visibleAmount < this.items.length && (h("ux-button", { key: '225865af89e68d04cba291e3ac24a112be69db36', class: "mf-service-reports__load-more", onClick: () => this.loadMore() }, this.t("mf-service-calls:serviceReports.loadMore")))));
    }
};

export { PaginatedReportItems as mf_service_reports_paginated_items };

//# sourceMappingURL=mf-service-reports-paginated-items.entry.js.map